import { useContext } from 'react';
import { GoogleOAuthProvider, NonOAuthError, useGoogleLogin } from '@react-oauth/google';
import { MainContext } from '../../../context/main.context';
import ManualController from '../../../hoc/ManualController';
import { googleLoginNative } from '../../../stores/auth.store';
import { ISuccessfulAuth } from '../../../interfaces';
import { LOGIN_BY_GOOGLE_ERROR } from '../../../common/errorCodes';


export const GoogleLoginPopup = ({ method }: { method: string }) => {
    const clientId: string = method === 'googlePopup'
        ? process.env.REACT_APP_GOOGLE_CLIENT_ID
        : process.env.REACT_APP_GOOGLE_ADULT_CLIENT_ID;

    return (
        <GoogleOAuthProvider clientId={clientId}>
            <LoginContent />
        </GoogleOAuthProvider>
    );
};

const LoginContent = () => {
    const { toggleLoader } = useContext(MainContext);
    const { manualRedirect } = ManualController();

    const login = useGoogleLogin({
        scope: 'openid profile email',
        prompt: 'select_account',
        flow: 'implicit',
        onSuccess: async (tokenResponse: any) => {
            const { access_token } = tokenResponse;

            _googleLoginNative(access_token)
        },
        onError: (err: any) => {
            console.error('onError Google', { err });
            toggleLoader(false);
        },
        onNonOAuthError: (nonOAuthError: NonOAuthError) => {
            if (nonOAuthError?.type === 'popup_closed') {
                toggleLoader(false);
                return;
            }

            console.error('onNonOAuthError Google', { nonOAuthError });
            toggleLoader(false);
        }
    });

    const handleLogin = () => {
        toggleLoader(true);
        login();
    };

    const _googleLoginNative = (accessToken: string) => {
        toggleLoader(true);

        googleLoginNative(accessToken).then((res: { data: ISuccessfulAuth }) => {
            const result = res?.data?.result;

            if (result) {
                manualRedirect(result, 'auth');
                return;
            }

            manualRedirect(res, 'auth', true, LOGIN_BY_GOOGLE_ERROR);
        }, err => {
            const errData = err?.response?.data || err;

            manualRedirect(errData, 'auth', true, LOGIN_BY_GOOGLE_ERROR);
        }).finally(() => {
            toggleLoader(false);
        });
    }

    return (
        <div className="auth-id" onClick={handleLogin}/>
    );
};
